<template>
    <div id="ordersummarysrootpopup"  :key="componentKey">
        <vs-popup title="" 
            :button-close-hidden="true" 
            :active.sync="isActive"
            @close="closePopUp"
            style="border-radius: 10px !important;"
            id="popUpOrderSummaryChat"
        >
            <div>
                <span id="display-span-orders">
                    <vs-icon v-if=" this.$route.name !== 'product-pre-orders'" @click="$emit('backToPreOrder')" class="mr-2" icon="keyboard_arrow_left" style="border: solid 1px; border-radius: 14px; cursor: pointer;"/>
                    <p class="ml-2" style="font-size: 20px; width: 360px;">Resumo do Pedido</p>
                    <div class="flex-end-align">
                        <vs-icon @click="closePopUp" class="mr-2" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right;"></vs-icon>
                    </div>
                </span>
            </div>

            <div class="ml-12 mr-6 mt-6">
                <span>
                    <p class="inline" style="font-size: 18px;"> {{ dataOfTurnIntoOrder.chatTicket.customer.name }} </p>
                </span> <br>
                <span v-if="
                  JSON.parse(dataOfTurnIntoOrder.address) !== null &&
                  JSON.parse(dataOfTurnIntoOrder.address).address !== 'none'
                ">
                    <p v-if="dataOfTurnIntoOrder.is_delivery" class="text-9x inline"> {{ getStreet(dataOfTurnIntoOrder.address) }}, N° {{ getNumber(dataOfTurnIntoOrder.address) }} </p>
                    <p v-else class="text-9x inline"> Pedido para retirada no Local </p>
                    <feather-icon
                        v-if="origin === 'chat'"
                        icon="EditIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        @click="$emit('editDeliveryOptions', dataOfTurnIntoOrder)"
                    />
                </span>
            </div>

            <div class="ml-16 mr-6">
                <vs-tabs v-model="selectedTab" ref="tabOrdersSummary">
                    <vs-tab label="Produtos" :disabled="!hasProduct" icon="shopping_basket" size="small">
                        <vs-table
                        ref="table" 
                        :data="listProductPreOrders"
                        noDataText="Sem dados disponíveis"
                        id="tableDataOrdersSummaryChat"
                        style="padding: 0 !important;"
                        @sort="sortFilter"
                        :sst="true"
                        >
                            <template slot="thead">
                                <vs-th class="text-base">
                                    Imagem
                                </vs-th>
                                <vs-th class="text-base" sort-key="products.name">
                                    Nome
                                </vs-th>
                                <vs-th class="text-base" style="width: 100%;">
                                    Preço com Desconto
                                </vs-th>
                                <vs-th class="text-base">
                                    Preço
                                </vs-th>
                                <vs-th class="text-base" sort-key="quantity">
                                    Quantidade
                                </vs-th>
                                <vs-th class="text-base" sort-key="quantity" v-if="showActions">
                                    Ações
                                </vs-th>
                            </template>
                            <template slot-scope="{data}"> 
                                <tbody>
                                    <vs-tr
                                        :data="tr" 
                                        :key="tr.id"
                                        :id="tr.id"
                                        v-for="(tr, index) in listProductPreOrders"
                                    > 
                                        <vs-td :data="tr.product.image">
                                        <div class="d-flex flex-row items-center justify-around"> <!-- justify-evenly -->
                                            <img v-if="tr.product.image !== undefined && tr.image !== '' && tr.image != null" :src="tr.image" style="width: 50px !important; height: 50px !important;">
                                            <img v-else src="@/assets/images/products/product_without_photo.png" style="width: 40px !important; height: 40px !important;">
                                        </div>
                                    </vs-td>

                                    <vs-td :data="tr.product.name">
                                        <div class="d-flex flex-row items-center justify-around"> <!-- justify-evenly -->
                                            <p class="text-center">
                                                {{ tr.product.name }}
                                            </p>
                                        </div>
                                    </vs-td>

                                        <vs-td>
                                            <p style="font-size: 13px;">
                                                <strong>R$ {{ ((tr.discount_price * tr.quantity).toFixed(2)).replace('.', ',')  }}</strong>
                                            </p>
                                        </vs-td>

                                        <vs-td>
                                            <p style="font-size: 13px;">
                                                <strong>R$ {{ ((tr.product.price * tr.quantity).toFixed(2)).replace('.', ',')  }}</strong>
                                            </p>
                                        </vs-td>

                                        <vs-td>
                                            <p style="font-size: 13px;">
                                                Qtde <strong style="color: #1196e1;"> {{ tr.quantity }} </strong>
                                            </p>
                                        </vs-td>

                                        <vs-td v-if="showActions">
                                            <div :class="origin === 'chat' ? 'mb-2' : 'mt-1'">
                                                <feather-icon
                                                    v-if="origin === 'chat'"
                                                    style="margin-top: 10px !important; margin-left: 6px !important;"
                                                    icon="EditIcon"
                                                    class="mr-1"
                                                    svgClasses="w-5 h-5 hover:text-primary stroke-current"  
                                                    @click="$emit('editProductOptions', {
                                                        data: dataOfTurnIntoOrder,
                                                        productData: listProductPreOrders
                                                    })"
                                                />

                                                <feather-icon
                                                    v-if="listProductPreOrders.length > 1"
                                                    class="trash"
                                                    icon="TrashIcon"
                                                    svgClasses="w-5 h-5 ml-1 hover:text-danger stroke-current"
                                                    @click="deleteProductOrder(tr.id)"
                                                />
                                            </div>
                                        </vs-td>
                                            
                                    </vs-tr>
                                </tbody>
                            </template>
                        </vs-table>
                    </vs-tab>
                
                    <vs-tab :disabled="!hasService" label="Serviços" icon="build" size="small">
                        <vs-table
                            v-if="hasService"
                            ref="table" 
                            :data="dataOfTurnIntoOrder.services"
                            noDataText="Sem dados disponíveis"
                            id="tableDataOrdersSummaryChat"
                            style="padding: 0 !important;"
                        >
                            <template slot="thead">
                                <vs-th class="text-base">
                                    Nome
                                </vs-th>
                                <vs-th class="text-base">
                                    Preço
                                </vs-th>
                                <vs-th class="text-base">
                                    Preço Com Desconto
                                </vs-th>
                                <vs-th class="text-base">
                                    Data e Hora de Realização
                                </vs-th>
                                <vs-th class="text-base">
                                    Usuário Vinculado
                                </vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <tbody>
                                    <vs-tr 
                                        :data="tr" 
                                        :key="tr.id"
                                        :id="tr.id"
                                        v-for="(tr, index) in dataOfTurnIntoOrder.services"
                                        ref="trService"
                                    >
                                        <vs-td :data="tr.name">
                                            <p class="ml-2">
                                                {{ tr.name }}
                                            </p>
                                        </vs-td>

                                        <vs-td :data="tr.price">
                                            <p class="ml-2">
                                               <strong> R$ {{ String(parseFloat(tr.price).toFixed(2)).replace('.', ',') }} </strong>
                                            </p>
                                        </vs-td>

                                        <vs-td :data="tr.discount_price">
                                            <p class="ml-4">
                                               <strong> R$ {{ String(parseFloat(tr.discount_price).toFixed(2)).replace('.', ',') }} </strong>
                                            </p>
                                        </vs-td>

                                        <vs-td :data="tr.id">
                                            <div class="align-input-date-time">
                                                <div class="ml-2">
                                                    <flat-pickr
                                                        :config="configDatePicker"
                                                        :placeholder="serviceDates[index] ? serviceDates[index] :'DD/MM/AAAA'"
                                                        v-model="serviceDates[index]"
                                                        class="w-full"
                                                        name="data"
                                                        style="width: 120px !important;"
                                                    />
                                                </div>
    
                                                <div class="ml-2">
                                                    <flat-pickr
                                                        class=" w-full"
                                                        name="hora"
                                                        v-model="serviceTimes[index]"
                                                        placeholder="HH:MM"
                                                        :config="configdateTimePicker"
                                                        style="width: 80px !important;"
                                                    />
                                                </div>
                                            </div>
                                        </vs-td>

                                        <vs-td :data="tr.id">
                                            <div>
                                                <vs-chip
                                                    @click="selectedUser ? $emit('removeSelectedUser') :$emit('linkUser')"
                                                    :color="selectedUser ? 'primary' : ''"
                                                    closable
                                                    :close-icon="selectedUser ? 'close' : 'add'"
                                                    class="ml-4"
                                                    style="font-size: 0.8rem;"
                                                >
                                                    {{ selectedUser ? selectedUser.name : 'Vincular usuário' }}
                                                </vs-chip>
                                            </div>
                                        </vs-td>
                                    </vs-tr>
                                </tbody>
                            </template>
                        </vs-table>
                    </vs-tab>

                    <vs-tab 
                    :disabled="dataOfTurnIntoOrder.files.length === 0 && !dataOfTurnIntoOrder.note" 
                    icon="description" 
                    size="small"
                    label="Arquivos e Observação"
                    >
                        <vs-table
                        ref="table" 
                        :data="dataOfTurnIntoOrder.files"
                        noDataText="Sem dados disponíveis"
                        id="tableDataOrdersSummaryChat"
                        style="padding: 0 !important;"
                        v-if="dataOfTurnIntoOrder.files.length > 0"
                        :pagination="dataOfTurnIntoOrder.files.length > 5"
                        >
                            <template slot="thead">
                                <vs-th class="text-base align-middle">
                                    Nome
                                </vs-th>
                                <vs-th class="text-base align-middle" >
                                    Ações
                                </vs-th>
                               
                            </template>

                            <template slot-scope="{data}">
                                <tbody>
                                    <vs-tr 
                                        :data="tr" 
                                        :key="tr.id"
                                        :id="tr.id"
                                        v-for="(tr, index) in data"
                                    >
                                        <vs-td :data="tr.name">
                                            <p class="ml-4" style="float: left !important;">
                                                {{ tr.name }}
                                            </p>
                                        </vs-td>

                                        <vs-td>
                                            <span style="float: left !important;" class="ml-4">
                                                <feather-icon 
                                                icon="DownloadIcon" 
                                                class="mr-4"
                                                svgClasses="h-5 w-5 hover:text-primary stroke-current"
                                                @click="downloadFile(tr.name, tr.url)"
                                                />

                                                <feather-icon
                                                icon="EditIcon"
                                                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                                @click="$emit('editNotesAndFiles')"
                                                />
                                            </span>

                                        </vs-td>

                                    </vs-tr>
                                </tbody>
                            </template>
                        </vs-table>

                        <div class="pl-3 mt-3 mb-2">
                            <span v-if="dataOfTurnIntoOrder.note">
                                <strong>Observação:</strong> {{ dataOfTurnIntoOrder.note }}
                            </span>

                            <span v-else class="mt-4">
                                <strong>Observação: </strong> <i>Nenhuma observação relacionada ao pré-pedido</i>
                            </span>

                            <feather-icon
                            v-if="!dataOfTurnIntoOrder.files.length > 0"
                            style="float: right !important;"
                            icon="EditIcon"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            @click="$emit('editNotesAndFiles')"
                            />
                        </div>
                    </vs-tab>

                    <vs-tab icon="import_contacts" 
                     size="small"
                     label="Modelo de Dados ..."
                     title="Modelo de Dados do Cliente"
                     :disabled="!dataOfTurnIntoOrder.reason"
                    >
                        <div v-if="currentKnow">

                            <div class="flex mt-4 mb-6">
                                <p style="font-size:16px;"><b>Editar Modelo de Dados do Cliente</b></p>
                                <feather-icon
                                    v-if="origin === 'chat'"
                                    style="cursor: pointer;"
                                    icon="EditIcon"
                                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                    @click="$emit('editCustomerKnow')"
                                    class="ml-2"
                                />
                            </div>

                            <vs-divider>
                                {{ currentKnow.description }}
                            </vs-divider>

                            <vs-textarea
                            v-validate="'required'"
                            v-if="currentKnow.use_observation && currentKnow.require_observation"
                            name="observation" class="w-full" label="Observações" v-model="observation"
                            :required="currentKnow.require_observation"
                            :disabled="true"
                            ></vs-textarea>

                            <vs-textarea
                            v-else-if="currentKnow.use_observation"
                            :required="currentKnow.require_observation"
                            name="observation" class="w-full" label="Observações" v-model="observation"
                            :disabled="true"
                            ></vs-textarea>

                            <div class="clear"></div>
                            <div>
                                <component
                                    v-for="(option, index) in options"
                                    :description="currentKnow.reason_options[index].description"
                                    :items="responses[index]"
                                    :index="index"
                                    :key="index"
                                    :is="option"
                                    @valueChanged="updateValue"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                    </vs-tab>
                </vs-tabs>

                <div>
                    <div class="align-div-ordersummary">
                        <div class="order-infos-div">
                            <div v-if="dataOfTurnIntoOrder.is_delivery">
                                <span class="mt-4" style="width: 100% !important; padding-right: 2px;">
                                    <!--<feather-icon
                                        style="float: right !important;"
                                        icon="EditIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"  
                                    />-->
                                </span>
                                <img :src="orderDelivery()" alt="Foto do Entregador">
                                <span> Entregador </span>
                            </div> 
                            <div v-else-if="showWithdrawal(dataOfTurnIntoOrder.address)"> 
                                <span style="width: 100% !important; padding-right: 2px;">
                                    <feather-icon
                                        v-if="origin === 'chat'"
                                        style="float: right !important;"
                                        icon="EditIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"  
                                        @click="$emit('editDeliveryOptions', dataOfTurnIntoOrder)"
                                    />
                                </span>
                                <vs-icon icon="store" size="40px"/>
                                <span> Retirada </span>
                            </div>

                            <div v-if="getType(dataOfTurnIntoOrder.payment_data) != 'none'">
                                <span style="width: 100% !important; padding-right: 2px;">
                                    <feather-icon
                                        v-if="origin === 'chat'"
                                        icon="EditIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"  
                                        style="float: right !important;"
                                        @click="$emit('editPaymentOptions', dataOfTurnIntoOrder)"
                                    />
                                </span>
                                <img v-if="getType(dataOfTurnIntoOrder.payment_data) == 'card'" src="@/assets/images/payment/card.png" alt="Imagem Cartão" id="cardResize"/>
                                <img v-else-if="getType(dataOfTurnIntoOrder.payment_data) == 'pix'" src="@/assets/images/payment/pix.png" alt="Imagem Pix" id="pixResize"/>
                                <img v-else-if="getType(dataOfTurnIntoOrder.payment_data) == 'cash'" src="@/assets/images/payment/cash.png" alt="Imagem Dinheiro" id="cashResize"/>
                                <span v-if="getType(dataOfTurnIntoOrder.payment_data)== 'card'" style="border-radius: 0 !important;"> Cartão </span>
                                <span class="mt-2" v-else-if="getType(dataOfTurnIntoOrder.payment_data) == 'pix'"> Pix </span>
                                <span class="mt-2" v-else-if="getType(dataOfTurnIntoOrder.payment_data) == 'cash'"> Dinheiro </span>
                            </div>
                            <div v-if="dataOfTurnIntoOrder.is_delivery">
                                <span style="width: 100% !important; padding-right: 2px;">
                                    <feather-icon
                                        v-if="origin === 'chat'"
                                        style="float: right !important;"
                                        icon="EditIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"  
                                        @click="$emit('editDeliveryOptions', dataOfTurnIntoOrder)"
                                    />
                                </span>
                                <vs-icon icon="motorcycle" size="medium"/>
                                <span> Entrega </span>
                            </div>
                        </div>
                        
                        <div>
                            <span v-if="dataOfTurnIntoOrder.is_delivery"> Entrega R$ {{ getDeliveryFee() }} </span>
                            <h4 class="mt-2"> 
                                Total R$ {{ this.socketReceived === true ? String(this.purchaseValueOfSocket.toFixed(2)).replace('.', ',') : String(dataOfTurnIntoOrder.purchase_value.toFixed(2)).replace('.', ',') }}
                            </h4>
                        </div>
                    </div>
    
                    <div class="ajuste-tamanho-vstd-orders mt-4">
                        <div>
                            <vs-button 
                                size="small" 
                                @click="lastTab.value ? openModalToTransform() : nextTab(lastTab.step)" 
                                class="mb-2"
                            >
                                <span style="font-size: 12px;">
                                    {{ lastTab.value ? 'Finalizar' : 'Próximo' }}
                                </span>
                                <vs-icon icon="keyboard_arrow_right" size="35px"/>
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
            <vs-popup title="Criar Pedido:" 
                id="popTransformNewProduct"
                :active.sync="modalToTransformIsActive"
            > 
                <p class="ml-1"> Clique em confirmar para fazer a criação de um novo Pedido! </p> 
                <div v-if="hasService">
                    <p class="ml-1"> Deseja enviar notificações ao cliente e ao usuário que prestará os serviços quando a data de agendamento estiver próxima? </p>
                    <br>
                    <vs-checkbox v-model="sendNotification" size="small">
                        <span class="ml-2">Enviar Notificações de Serviços</span>
                    </vs-checkbox>
                </div> <br>


                <div v-if="sendNotification && hasService">
                    <span  class="flex" style="margin-left: 4px !important;">
                        <feather-icon
                        class="play-audio-icon mr-1"
                        svgClasses="w-5 h-5 stroke-current"
                        icon="BellIcon"
                        />

                        <label for="notifyOptions" class="ml-2"><strong>Notificação em:</strong></label>
                    </span>
                
                    <v-select
                        v-model="notifyAt"
                        :options="notifyOptions"
                        style="width: 312.5px;"
                        class="ml-1 mt-3"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                    
                    <span v-if="notifyAt.value === 'custom'">

                        <div class="align-input-date-time mt-6">
                            <div class="ml-1">
                                <vs-input-number 
                                    v-model="customValue" 
                                    min="1"
                                    :max="customRecurrence.max"
                                />
                            </div>
                            
                            <div class="ml-3">
                                <v-select
                                    :options="[
                                        { label: 'minuto(s) antes', max: 60, type: 'minute' },
                                        { label: 'hora(s) antes', max: 24, type: 'hour' },
                                        { label: 'dia(s) antes', max: 60, type: 'day' },
                                    ]"
                                    v-model="customRecurrence"
                                    style="width: 195px !important;"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                />
                            </div>
                        </div>
                    </span>
                </div>
                

                <div class="w-full d-flex justify-content-flex-end">
                    <vs-button color="success" class="mt-5" @click.stop="finishPreOrder">Confirmar</vs-button>
                </div>
            </vs-popup>

            <vs-popup title="Estoque insuficiente para pré-pedido" 
                id="popTransformNewProduct"
                :active.sync="modalToChangeQuantity"> 
                <p>Por favor, observe que a quantidade solicitada do produto <b>{{ this.productToChange }}</b> 
                    excede o estoque atual. Por favor, revise a quantidade desse produto em seu pré-pedido 
                    antes de transformá-lo em um pedido para garantir que possamos atender sua solicitação. Obrigado!
                </p> <br>
            </vs-popup>

        </vs-popup>
    </div>
</template>

<script>
    import VsDropdown from "@/components/vs-dropdown/dropdown.vue";
    import VsDropdownMenu from "@/components/vs-dropdown/dropdown-menu.vue";
    import VsDropdownItem from "@/components/vs-dropdown/dropdown-item.vue";
    import orderProduct from "@/http/requests/orderProduct";
    import order from "@/http/requests/orders";
    import moduleOrder from "@/store/order/moduleOrder";
    import Product from '@/http/requests/product';
    import customerKnow from '@/http/requests/knowledge';
    import flatPickr from 'vue-flatpickr-component';
    import vSelect from 'vue-select';
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import 'flatpickr/dist/flatpickr.css';
    import axios from 'axios'

    import IntField        from '@/views/reason-response-fields/Int'
    import TextField       from '@/views/reason-response-fields/Text'
    import RadioField      from '@/views/reason-response-fields/Radio'
    import SelectField     from '@/views/reason-response-fields/Select'
    import BooleanField    from '@/views/reason-response-fields/Boolean'
    import DecimalField    from '@/views/reason-response-fields/Decimal'
    import CurrencyField   from '@/views/reason-response-fields/Currency'
    import CheckboxField   from '@/views/reason-response-fields/Checkbox'

    export default {
        name: 'OrderSummaryPopUp',
        components: {
            flatPickr,
            vSelect,
            VsDropdown,
            VsDropdownMenu,
            VsDropdownItem,
            IntField,
            TextField,
            RadioField,
            SelectField,
            BooleanField,
            DecimalField,
            CurrencyField,
            CheckboxField
        },
        emits: [
            'isActiveFalse',
            'backToPreOrder',
            'editDeliveryOptions',
            'editPaymentOptions',
            'editProductOptions'
        ],
        data() {
            return {
                listProductPreOrders: [],
                productToChange: null,
                modalToChangeQuantity: false,
                total: 0,
                address: '',
                orderBy: {
                    name: 'products.name',
                    type: 'ASC'
                },
                socketReceived: false,
                purchaseValueOfSocket: 0.0,
                selectedTab: 0,
                componentKey: 0,
                configDatePicker: {
                    enableTime: false,
                    noCalendar: false,
                    time_24hr: true,
                    dateFormat: 'd/m/Y',
                    minDate: new Date()
                },
                configdateTimePicker: {
                    enableTime: true,
                    noCalendar: true,
                    time_24hr: true
                },
                serviceDates: [],
                serviceTimes: [],
                customValue: 1,
                customRecurrence: { label: 'minuto(s) antes', max: 60, type: 'minute' },
                sendNotification: true,
                services: [],
                notifyOptions: [
                    { label: '1 minuto antes', value: 60 },
                    { label: '5 minutos antes', value: 300 },
                    { label: '10 minutos antes', value: 600 },
                    { label: '15 minutos antes', value: 900 },
                    { label: '30 minutos antes', value: 1800 },
                    { label: '1 hora antes', value: 3600 },
                    { label: '1 dia antes', value: 86400 },
                    { label: 'Personalizar', value: 'custom' }
                ],
                notifyAt: { label: "1 minuto antes", value: 60 },
                currentKnow: {},
                customerKnow: {},
                responses: [],
                options: [],
                observation: "",
                idPreOrder: null,
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            modalToTransformIsActive: {
                type: Boolean,
                required: true
            },
            dataOfTurnIntoOrder: {
                type: Object,
                required: true
            },
            selectedUser: {
                type: Object,
                required: false
            },
            customer: {
                type: Object,
                required: false
            },
            origin: {
              type: String,
              required: false,
              default: 'chat'
            },
        },
        methods: {
            closePopUp() {
                this.socketReceived = false
                this.isActive = false;
                this.$emit('isActiveFalse');
            },
            async deleteProductOrder(id) {
                await orderProduct.deleteOrderProduct(id)
                .then(() => {
                    
                    this.fetchProductPreOrders();

                    this.$vs.notify({
                        color: 'success',
                        title: 'Sucesso!', 
                        text: 'Produto deletado do orçamento com sucesso!'
                    });

                })
                .catch((exception) => {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Ocorreu um erro ao deletar o produto!', 
                        text: 'Erro ao deletar o produto, por favor nos contate para corrigir-mos!'
                    });

                    console.log(exception)
                });
            },
            async fetchProductPreOrders() {
                const idPreOrder = await this.idPreOrder;
                
                await orderProduct.fetch(idPreOrder, this.orderBy.name, this.orderBy.type)
                .then((response) => {
                    const parsedData = response.data.data.getOrderProduct;
                    
                    if (parsedData.length !== 0) {
                        this.dataOfTurnIntoOrder.purchase_value = parsedData[0].order.purchase_value;
                    }
                    this.listProductPreOrders = parsedData;
                    
                    if (!this.hasProduct) {
                        setTimeout(() => {
                            this.$refs.tabOrdersSummary.value = 1;
                            this.$refs.tabOrdersSummary.$data.childActive = 1;
                        }, 300);
                    }

                })
                .catch((exception) => {
                    if (this.hasProduct) {
                        
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Ocorreu um erro ao consultar os produtos!', 
                            text: 'Erro ao consultar os produtos, por favor nos contate para corrigir-mos!'
                        });

                        console.log(exception)
                    }
                });

                if (this.hasService) {
                    this.services = this.dataOfTurnIntoOrder.services;
                }
            },
            formatScheduleAt(dateStr) {
                const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
                const date = new Date(dateStr);
                return date.toLocaleDateString('pt-BR', options).replace(/\//g, '-').replace(/,/g, '');
            },
            orderDelivery() {
                return this.$store.state.AppActiveUser.image;
            },
            async openModalToTransform() {
                if (this.hasService) {
                    
                    const dates = (this.serviceDates.filter(Boolean).length);
                    const times = (this.serviceTimes.filter(Boolean).length);

                    if (dates !== this.dataOfTurnIntoOrder.services.length ||
                        times !== this.dataOfTurnIntoOrder.services.length
                    ) { return this.$vs.notify({
                            color: 'danger',
                            time: 5000,
                            title: 'Aviso:',
                            text: 'Você deve preencher os campos de Data e Horário de realização do Serviço! A data e horário devem ser no futuro!'
                        });
                    }
                }

                // erp_id 1 é trier
                // erp_id 2 é alpha7
                if (
                    (this.dataOfTurnIntoOrder.erp_id === null ||this.dataOfTurnIntoOrder.erp.erp_id === 2)
                    ||(this.dataOfTurnIntoOrder.erp.erp_id !== 1)
                ) {
                    this.modalToTransformIsActive = true;
                    return;
                } 
                if (this.customer.document_register) {
                    await this.checkAmount(this.dataOfTurnIntoOrder.erp_id);
                    return;
                }

                this.$emit('addCustomerDocument')
            },
            async finishPreOrder() {
                let serviceData = {
                    send_notification: undefined,
                    service: undefined
                };
    
                if (this.hasService) {
                    serviceData = {
                        send_notification: this.sendNotification
                    };

                    const serviceDataArray = this.dataOfTurnIntoOrder.services.map(
                        (service, index) => {
                            return {
                                id: service.id,
                                scheduled_at: this.serviceDates[index] + ' ' + this.serviceTimes[index],
                                notify_at: this.formatedNotifyAt(this.serviceDates[index], this.serviceTimes[index]),
                                user_email: this.selectedUser.email
                            };
                        }
                    );

                    Object.assign(serviceData, {
                        service: JSON.stringify(serviceDataArray)
                    });
                }
                
                const customer_id = this.dataOfTurnIntoOrder.reason ? this.dataOfTurnIntoOrder.chatTicket.customer_id : undefined
                const reason_id = this.dataOfTurnIntoOrder.reason ? this.dataOfTurnIntoOrder.reason.id : undefined
                order.transformPreOrderIntoOrder(this.dataOfTurnIntoOrder.id, serviceData.send_notification, serviceData.service, customer_id, reason_id)
                .then((response) => {
                    this.modalToTransformIsActive = false;
                    this.socketReceived = false
                    this.$emit('isActiveFalse');

                    this.fetchNewData();

                    return this.$vs.notify({
                        color: 'success',
                        title: 'Sucesso!',
                        text: 'Pedido criado com sucesso!'
                    })
                })
                .catch((exception) => {
                    console.log(exception);
                    this.modalToTransformIsActive = false;
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Ocorreu um erro ao criar novo Pedido!',
                        time: 5000,
                        text: 'Você deve preencher os campos de Data e Horário de realização do Serviço!' 
                    });

                    return this.$vs.notify({
                        color: 'danger',
                        title: 'A data e horário de realização deve ser no futuro!',
                        time: 5000
                    });
                });
            },
            async fetchNewData() {
                if (!moduleOrder.isRegistered) {
                    this.$store.registerModule('order', moduleOrder)
                    moduleOrder.isRegistered = true
                }
                await this.$store.dispatch("order/fetchAll", {
                  page: 1,
                  itemsPerPage: 4
                });
                await this.$store.dispatch("order/fetchAllPreOrders", {
                  page: 1,
                  itemsPerPage: 4
                });
            },
            getNumber(data) {
                let parsedNumber;

                try {
                    parsedNumber = JSON.parse(JSON.parse(data)).number;
                } catch {
                    parsedNumber = JSON.parse(data).number;
                }

                return parsedNumber;
            },
            getStreet(data) {
                let parsedAddress;

                try {
                    parsedAddress = JSON.parse(JSON.parse(data)).address;
                } catch {
                    parsedAddress = JSON.parse(data).address;
                }

                return parsedAddress;
            },
            getDeliveryFee() {
                let parsedDeliveryFee;

                try {
                    parsedDeliveryFee = JSON.parse(JSON.parse(this.dataOfTurnIntoOrder.address)).delivery_fee;
                } catch {
                    parsedDeliveryFee = JSON.parse(this.dataOfTurnIntoOrder.address).delivery_fee;
                }

                return String(parsedDeliveryFee).replace('.', ',');
            },
            getType(data) {
                return (JSON.parse(data)).type;
            },
            async sortFilter(sortName) {
                if (sortName !== null) {
                    if (sortName !== this.orderBy.name) {
                        this.orderBy.name = sortName;
                        this.orderBy.type = 'ASC';
                    } else if (this.orderBy.type !== "" && this.orderBy.type === "ASC") {
                        this.orderBy.type = 'DESC';
                    } else if (this.orderBy.name === sortName && this.orderBy.type === "DESC") {
                        this.orderBy.name = 'products.name';
                        this.orderBy.type = 'ASC';
                    }
                    await this.fetchProductPreOrders();
                }
            },
            async checkAmount(erpId) {
                this.$vs.loading({
                    type: 'radius'
                });
                let check = [];
                check = this.dataOfTurnIntoOrder.orderProducts.map(item => item.product.integration_id);

                if (check.length === 1 && check[0] === null) {
                    this.modalToTransformIsActive = true;
                }
                else {
                    try {
                        const response = await Product.updateProductErpInfos(check, erpId)

                        for (let index = 0; index < check.length; index++) {
                            let quantity = this.dataOfTurnIntoOrder.orderProducts[index].quantity;
                            let responseAmount = response.data.data.updateProductErpInfos.items[index].amount;

                            if (!this.enableNegativeStock && quantity > responseAmount && responseAmount !== 0) {
                                this.productToChange = this.dataOfTurnIntoOrder.orderProducts[index].product.name
                                this.modalToChangeQuantity = true
                                break
                            }
                        }

                        if (!this.modalToChangeQuantity) {
                            this.modalToTransformIsActive = true;
                        }
                    } catch (error) {
                        console.log("ERROR",error)
                    }
                }
                this.$vs.loading.close();
            },
            formatDate(inputDate) {
                const [year, month, day] = inputDate.split('-');
                return `${day}/${month}/${year}`;
            },
            downloadFile(documentName, url, documentMimetype) {
                axios.get(url, {
                    responseType: 'blob'
                }).then(res => {
                    var blob = new Blob(
                    [res.data],
                    { type: `${documentMimetype};charset=utf-8;` }
                    )

                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = documentName
                    link.click()
                    window.URL.revokeObjectURL(link.href)
                });
            },
            formatedNotifyAt(date, time) {

                const result  = this.notifyAt.value === 'custom' ? this.notifyAtInSeconds : this.notifyAt.value
                const seconds = parseInt(result, 10);

                const dateParts = date.split(/[\/\-]/);
                const day = parseInt(dateParts[0], 10);
                const month = parseInt(dateParts[1], 10) - 1;
                const year = parseInt(dateParts[2], 10);

                const timeParts = time.split(':');
                const hours = parseInt(timeParts[0], 10);
                const minutes = parseInt(timeParts[1], 10);

                const dateTime = new Date(year, month, day, hours, minutes);

                dateTime.setSeconds(dateTime.getSeconds() - seconds);

                if (dateTime.getMonth() !== month) {

                    dateTime.setMonth(month - 1);
                    if (month === 0) {
                        dateTime.setFullYear(year - 1);
                    }
                }

                const newDay = dateTime.getDate();
                const newMonth = dateTime.getMonth() + 1;
                const newYear = dateTime.getFullYear();
                const newHours = dateTime.getHours();
                const newMinutes = dateTime.getMinutes();

                const formattedDate = `${newDay < 10 ? '0' : ''}${newDay}/${newMonth < 10 ? '0' : ''}${newMonth}/${newYear}`;
                const formattedTime = `${newHours < 10 ? '0' : ''}${newHours}:${newMinutes < 10 ? '0' : ''}${newMinutes}`;

                return formattedDate + ' ' + formattedTime;
            },
            nextTab(step) {
                if (!this.hasProduct && this.selectedTab === 0) {
                    setTimeout(() => {
                        this.selectedTab = this.selectedTab + 1
                        this.$refs.tabOfPreOrderSummary.value = this.selectedTab ;
                        this.$refs.tabOfPreOrderSummary.$data.childActive = this.selectedTab ;
                    }, 200);
                }

                setTimeout(() => {
                    this.selectedTab = this.selectedTab + step
                    this.$refs.tabOrdersSummary.value = this.selectedTab ;
                    this.$refs.tabOrdersSummary.$data.childActive = this.selectedTab ;
                }, 200);
            },
            resetOptions() {
                this.currentKnow.reason_options.forEach((opt, idx) => {
                let defaultValue = null
                if (opt.reason_option_kind.tag === 'text') {
                    this.options.push(TextField)
                }
                if (opt.reason_option_kind.tag === 'int') {
                    this.options.push(IntField)
                    defaultValue = "0"
                }
                if (opt.reason_option_kind.tag === 'currency') {
                    this.options.push(CurrencyField)
                    defaultValue = "0"
                }
                if (opt.reason_option_kind.tag === 'decimal') {
                    this.options.push(DecimalField)
                defaultValue = "0"
                }
                if (opt.reason_option_kind.tag === 'select') {
                    this.options.push(SelectField)
                }
                if (opt.reason_option_kind.tag === 'radio') {
                    this.options.push(RadioField)
                    defaultValue = "false"
                }
                if (opt.reason_option_kind.tag === 'checkbox') {
                this.options.push(CheckboxField)
                    defaultValue = "false"
                }
                if (opt.reason_option_kind.tag === 'boolean') {
                    this.options.push(BooleanField)
                    defaultValue = "false"
                }
                let items = [null]
                if (opt.reason_option_items && opt.reason_option_items.length > 0) {
                    items = opt.reason_option_items
                }
                items.forEach((item) => {
                    let itemId = null
                    let itemDescription = null
                    this.responses[idx] = this.responses[idx] ? this.responses[idx] : []
                    if (item) {
                        itemId = item.id
                        itemDescription = item.description
                    }
                    this.responses[idx].push({
                        reason_option_is_required: opt.is_required,
                        reason_option_item_id: itemId,
                        description: itemDescription,
                        reason_option_id: opt.id,
                        value: defaultValue
                        })
                    })
                })
            },
            loadOptionsKnow(observation, knowOption){
                let currentOptions = this.currentKnow.reason_options
                if (!currentOptions) { return; }
                                
                this.observation = !observation.includes('null') ? observation : null
                
                knowOption.forEach((option) => {
                    let knowOptionIndex = currentOptions.findIndex((e) => { return e.id == parseInt(option.id) })
                    
                    if ( knowOptionIndex === -1 ){ return; }
                    
                    let knowItemIndex = currentOptions[knowOptionIndex].reason_option_items.findIndex((e) => { return e.id == parseInt(option.option_item_id) })
                    knowItemIndex     = knowItemIndex !== -1 ? knowItemIndex : 0
                    if ( option.type === "select" || option.type === "radio" ){
                        this.updateValue(knowOptionIndex, knowItemIndex, true)
                    } else {
                        this.updateValue(knowOptionIndex, knowItemIndex, option.value)
                    }
                    if (option.type === "checkbox") {
                        
                        option.value.split(',').forEach((value) => {
                            knowItemIndex = currentOptions[knowOptionIndex].reason_option_items.findIndex((e) => { return e.description == value })
                            if ( knowItemIndex !== -1 ) { this.updateValue(knowOptionIndex, knowItemIndex, true) }
                        })
                    }
                })
            },
            async fetchCustomerKnow() {
                if ( !this.currentKnow ){ return }
                const customerId = this.dataOfTurnIntoOrder.chatTicket.customer.id
                await customerKnow.fetch(customerId, this.currentKnow.id)
                .then((response) => {
                    this.customerKnow = response.data.data.customerKnowledge[0];
                    this.prepareOptionsKnow()
                })
                .catch((error) => { console.error(error) })
            },
            prepareOptionsKnow(){
                if( !this.customerKnow ){ return this.resetOptions(); }
                let observation     = this.customerKnow.observation
                let knowOption      = this.customerKnow.reason_option
                this.resetOptions();
                this.loadOptionsKnow(observation, knowOption)
            },
            updateValue(index, itemIndex, value) {
                let opts = {
                    reason_option_is_required: this.responses[index][itemIndex].reason_option_is_required,
                    reason_option_item_id: this.responses[index][itemIndex].reason_option_item_id,
                    reason_option_id: this.responses[index][itemIndex].reason_option_id,
                    description: this.responses[index][itemIndex].description,
                    value: value.toString()
                }
                let list = this.responses[index]
                list.splice(itemIndex, 1, opts)
                this.responses.splice(index, 1, list)
            },
            showWithdrawal(address) {
                if (address) {
                    const formatedAddress = JSON.parse(address);
                    if (formatedAddress.address === 'none') {
                        return false;
                    }
                }
                return true;
            },
            getFormatedAddress() {
                if (this.dataOfTurnIntoOrder.address) {
                    return JSON.parse(this.dataOfTurnIntoOrder.address).address !== 'none'
                }
                return false;
            }
        },
        watch: {
            async dataOfTurnIntoOrder(value) {
                this.idPreOrder = value.id;
            },
            'isActive': {
                async handler(val) {
                    this.socketReceived = false;

                    if (val) {
                        this.fetchProductPreOrders();

                        this.options      = [];
                        this.responses    = [];
                        this.observation  = null;
                        this.currentKnow  = [];
                        this.customerKnow = [];

                        this.usersList = [];
                        this.componentKey++;

                        this.serviceDates = [];
                        this.serviceTimes = [];

                        if (this.hasService) {
                            this.dataOfTurnIntoOrder.services.forEach(item => {
                                const [date, time] = item.scheduled_at.split(' ');

                                this.serviceTimes.push(time);
                                this.serviceDates.push(this.formatDate(date));
                            });
                        }

                        if (this.dataOfTurnIntoOrder.customer_knowledge_content) {
                            this.currentKnow  = JSON.parse(this.dataOfTurnIntoOrder.customer_knowledge_content);
                            this.customerKnow = this.currentKnow;
                            
                            await this.fetchCustomerKnow();
                        }

                    }
                },
                deep: true
            },
            customRecurrence(val) {
                if (this.customValue > val.max) {
                    this.customValue = val.max
                }
            }
        },
        async mounted() {
            this.$events.off('newValue')
            this.$events.on('newValue', ({price,quantity}) => {
                this.updatePrice(price, quantity);
            })
        },
        created() {
            this.$events.off('NewOrderProductInserted')
            this.$events.on('NewOrderProductInserted', (data) => {
                this.idPreOrder = data.data.order_id;
                this.fetchProductPreOrders();
            });

            this.$events.off('NewPurchaseValueOfOrder')
            this.$events.on('NewPurchaseValueOfOrder', (data) => {
                this.purchaseValueOfSocket = data.data.purchase_value;
                this.socketReceived = true;
            });
        },
        computed: {
            hasProduct() {
                return this.dataOfTurnIntoOrder.orderProducts.length !== 0;
            },
            hasService() {
                return this.dataOfTurnIntoOrder.services.length !== 0;
            },
            showActions() {
                if (this.origin === 'chat') {
                    return true;
                }
                else if (this.origin !== 'chat' && this.listProductPreOrders.length > 1) {
                    return true;
                }

                return false;
            },
            notifyAtInSeconds() {
                if (this.customRecurrence.type === 'minutes') { return this.customValue * 60; }

                else if (this.customRecurrence.type === 'hour') { return this.customValue * 3600; }

                else if (this.customRecurrence.type === 'day') { return this.customValue * 24 * 60 * 60; } 

                return this.customValue;
            },
            lastTab() {
                const know = this.currentKnow ? Object.entries(this.currentKnow).length !== 0 : false

                if (this.selectedTab === 0 && this.hasService) {
                    return {value:false, step: 1}
                }

                else if(
                    this.selectedTab === 0 
                    && (this.dataOfTurnIntoOrder.files.length > 0
                    || this.dataOfTurnIntoOrder.note)
                ) 
                {
                    return {value: false, step: 2}
                }

                else if(this.selectedTab === 0 && know) {
                    return {value: false, step: 3}
                }

                else if(
                    this.selectedTab === 1
                    && (this.dataOfTurnIntoOrder.files.length > 0
                    || this.dataOfTurnIntoOrder.note)
                ) {
                    return {value: false, step: 1}
                }

                else if (this.selectedTab === 1 && know) {
                    return {value: false, step: 2}
                }

                else if(this.selectedTab === 2 && know) {
                    return {value: false, step: 1}
                }

                return {value: true, step: 0};
            },
            enableNegativeStock() {
                return !!Number(this.$store.state.settings.settings.enable_negative_stock);
            },
        }
    }
</script>

<style lang="scss">
#display-span-orders {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    div {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        i.vs-icon.notranslate.icon-scale.mr-2.material-icons.null:last-of-type {
            cursor: pointer;
        }
    }
}
#popUpOrderSummaryChat div.vs-popup {
    .vs-popup--content {
        padding: 15px;
        margin: 0;
    }
    margin: 0;
    border-radius: 18px !important;
    border: solid 1.2px;
    border-color: rgba(18, 17, 17, 0.769);
    width: 800px !important;
    .vs-popup--header {
        background-color: transparent !important;
        .vs-popup--title {
            background-color: transparent !important;
            h3 {
                background-color: transparent !important;
            }
        }
    }
    header {
        background-color: transparent !important;
    }

    .ajuste-tamanho-vstd-orders {
        float: right;
        padding-right: 10px;
        width: 160px;
        border-width: 1px 0px 1px 0px; 
        div {
            display: flex;
            float: right;
            button {
                display: flex;
                border-radius: 15px;
                height: 35px;
                padding: 0px 16px 0px 25px;
                justify-content: center;
            }
            span.vs-button-text.vs-button--text {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
            }
        }
    }

    div.align-div-ordersummary {
        display: flex;
        justify-content: space-between;
        margin-left: 14px;
        margin-right: 14px;

        .order-infos-div {
            display: flex;
            div {
                border: solid 2px #abb3b257; 
                border-radius: 14px;
                cursor: pointer;
                margin: 8px;
                margin-left: 0;
                width: 90px;
                height: 80px;
                display: flex;
                flex-direction: column;
                align-content: center;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
        
                span {
                    font-size: 10px;
                    text-align: center;
                }
                img {
                    width: 36px;
                    height: 36px;
                    border-radius: 40px;
                }
            }
        }
    }
    #tableDataOrdersSummaryChat {
        .vs-con-tbody.vs-table--tbody {
            background-color: transparent !important;
            border: 0 !important; 
        }
        table.vs-table.vs-table--tbody-table {
            border-collapse: separate;
            border-spacing: 0 0.5rem;
            padding: 0 1rem;
        }
        .vs-table-text {
            text-align: center;
        }
        tbody {  
            tr {
                td {
                    padding: 0px;
                    border-style: solid; 
                    border-color: #b6bebd6e;
                    height: 4em;
                }
                td.td.vs-table--td {
                    text-align: center;
                }
                td:first-of-type {
                    border-top-left-radius: 18px !important; 
                    border-bottom-left-radius: 18px !important; 
                    border-width: 1px 0px 1px 1px;
                }
                td:nth-of-type(2), td:nth-of-type(3), td:nth-of-type(4), td:nth-of-type(5) {
                    border-width: 1px 0px 1px 0px; 
                }
                td:last-of-type {
                    border-width: 1px 1px 1px 0px;
                    border-top-right-radius: 18px !important;
                    border-bottom-right-radius: 18px !important;
                    padding-right: 10px;
                }
            }
        }
    }
    #pixResize {
        width: 60px !important;
        height: 23px !important;
    }
    #cardResize {
        border-radius: 0 !important;
        height: 35px !important;
        width: 50px !important;
    }
    #cashResize {
        width: 40px !important;
        height: 30px !important;
    }
}
#popTransformNewProduct {
    .vs-popup {
        width: 500px !important;
    }
}
</style>
